import axiosInstance from '../axiosInstance';

const getAuditLogsAPI = async (params) => {
    let url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/audit${params}`;
    return await axiosInstance.get(url);
};

const getAuditLogByIdAPI = async (id) => {
    let url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/audit/${id}`;
    return await axiosInstance.get(url);
};

const downloadAuditLogsAPI = async (params) => {
    let url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/audit/report/download?${params}`;
    return await axiosInstance.get(url, {
        responseType: 'blob',
    });
};
const getAuditFilterOptionsAPI = async () => {
    let url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/audit/filter-options`;
    return await axiosInstance.get(url);
};

export default {
    getAuditLogsAPI,
    getAuditLogByIdAPI,
    downloadAuditLogsAPI,
    getAuditFilterOptionsAPI,
};
